import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../util/pageTitles';
import React from 'react';
import { withRouter } from '../../util/withRouter';
import { connect } from 'react-redux';
import moment from 'moment';
import { Button, DropdownButton, OverlayTrigger, Tooltip } from 'react-bootstrap';

import NoData from '../../components/NoData/NoData';
import Loading from '../../components/Loading/Loading';
import Confirm from '../../components/Confirm/Confirm';

import {
  requestData,
  selectPortfolio,
  deletePortfolio,
  saveSelected,
  saveSelectedPortfolioBreakdown,
  listAll,
  updateDateRange,
  handleError
} from './PortfolioActions';
import { DateRangePicker } from '../../components/Filter/components/global/DateRangePicker';
import {listAll as streamsAll} from '../ReportConfig/ReportActions';
import LineChart from '../ReportConfig/components/LineChart';
import ValueStreamSelector from '../ReportConfig/components/ValueStreamSelector';
import SubscribeEDAddOn from '../../components/SubscribeEDAddOn/SubscribeEDAddOn';

import settingsIcon from '../../assets/img/settings-icon.svg';
import createIcon from '../../assets/img/createDashboard-icon.svg';
import lineChartOnIcon from '../../assets/img/line-chart-icon-on.svg';
import deleteIcon from '../../assets/img/delete.svg';
import editIcon from '../../assets/images/edit-blue.svg';

import portfolioIcon from '../../assets/images/portfolio-default-icon.jpg';

import expandIcon from '../../assets/img/zoom-icon-off.svg';
import collapseIcon from '../../assets/img/zoom-icon-on.svg';

import '../../util/moment-duration';

import { PieChartWidget } from '../ReportConfig/components/PieChartWidget';

import { trackPortfolioView } from '../../util/mixpanel';

import { getPortfolioAccessRights } from '../../util/permissions';
import { GridStackManager } from '../../util/gridStackUtils';
import { reportHasNoData, leavesFullScreen, cardIsEmpty } from '../../util/reportUtils';
import { ChartPlaceholder } from '../../components/CardViews/CardViews';

import '../ReportConfig/Reports.scss';
import _ from 'lodash';

function formatCycletimeLabel(point, timePrecision) {
  const duration = moment.duration(point.y, 'minutes').format(timePrecision, { trim: 'mid both' });
  return `(${duration}) ${(point.percentage || 0).toFixed(2)}%`;
}

function formatThroughputLabel(point) {
  return `${(point.percentage || 0).toFixed(2)}% (${point.y} ${point.y > 1 ? 'items' : 'item'})`;
}

const TRENDS_ROWS = { ctb: { row: 1 }, 'throughput-trends': { row: 1 }, wip: { row: 2 }, wipAge: { row: 2 } };
const DISTRIBUTION_ROWS = {
  cycletime: { row: 1 },
  throughput: { row: 1 },
  'percentile-trends': { row: 2 },
  'flow-efficiency': { row: 2 }
};

const DragIcon = ({ customizeMode }) => (
  <div className={`card-drag ${customizeMode ? '' : 'hidden'}`}>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 2v20" />
      <path d="m15 19-3 3-3-3" />
      <path d="m19 9 3 3-3 3" />
      <path d="M2 12h20" />
      <path d="m5 9-3 3 3 3" />
      <path d="m9 5 3-3 3 3" />
    </svg>
  </div>
);

class Portfolios extends React.Component {
  constructor(props) {
    super(props);
    this.trendsGridRef = React.createRef();
    this.distributionGridRef = React.createRef();
    this.gridManagers = [];
    this.state = {
      comparison: false,
      percentile: (props.filters && props.filters.percentile) || 85,
      threshold: (props.filters && props.filters.threshold) || 5,
      dateRange: props.dateRange || 'lastMonth',
      dateFormat: (props.filters && props.filters.dateFormat) || 'D/MM/YY',
      isFullScreen: '',
      cycletime: {
        search: '',
        value: [],
        name: '',
        drilldown: '',
        open: false
      },
      throughput: {
        search: '',
        value: [],
        name: '',
        drilldown: '',
        open: false
      },
      wip: {
        search: '',
        value: [],
        name: '',
        open: false
      },
      wat: {
        search: '',
        value: [],
        name: '',
        open: false
      },
      page: 1,
      th: false,
      wp: false,
      wat: false,
      ct: false,
      fe: false
    };
  }

  componentDidMount() {
    this.chartsInitialized = false;
    const currentSelectedPortfolioIdFromProps = this.props.selectedPortfolio && this.props.selectedPortfolio._id;
    const portfolioIdToLoad = this.props.routeParams.id || currentSelectedPortfolioIdFromProps;

    if (!this.props.streams.length && !this.props.streamsLoading) {
      this.props.getStreams();
    }

    if (portfolioIdToLoad) {
      this.props.requestData(portfolioIdToLoad);
    } else if (this.props.selectedPortfolio && this.props.stats && this.props.stats.cycletimeBreakdowns) {
      this._syncBreakdownSettingsAndCharts(this.props);
    }

    this.initializeGridStack();
  }

  async initializeGridStack() {
    const grids = [
      [this.trendsGridRef, TRENDS_ROWS],
      [this.distributionGridRef, DISTRIBUTION_ROWS]
    ].filter(([ref]) => ref.current);
    if (!grids.length) return;

    const managers = grids.map(([ref, rows]) => {
      const manager = new GridStackManager(ref, {
        cellHeight: 350,
        column: 12
      });
      manager.setWidgetConfig(rows);
      return manager;
    });
    this.gridManagers = managers;

    await Promise.all(managers.map(manager => manager.loadGridStack()));

    if (this.gridManagers === managers) {
      managers.forEach(manager => manager.triggerChartResize());
    }
  }

  componentWillUnmount() {
    this.gridManagers.forEach(manager => manager.destroy());
    this.gridManagers = [];
  }

componentDidUpdate(prevProps, prevState) {
    const prevPortfolioIdFromProps = prevProps.selectedPortfolio && prevProps.selectedPortfolio._id;
    const currentPortfolioIdFromProps = this.props.selectedPortfolio && this.props.selectedPortfolio._id;
    const prevEffectivePortfolioId = prevProps.routeParams.id || prevPortfolioIdFromProps;
    const currentEffectivePortfolioId = this.props.routeParams.id || currentPortfolioIdFromProps;

    const portfolioContextChanged = prevEffectivePortfolioId !== currentEffectivePortfolioId;

    const fullScreen = this.state.isFullScreen;
    if (leavesFullScreen(fullScreen, this.props.trends, this.props.loading)) {
      this.setState({ isFullScreen: '' }, () => this.updateFontSize(fullScreen));
    }
    const selectedPortfolioObjectChanged = !_.isEqual(prevProps.selectedPortfolio, this.props.selectedPortfolio);

    if (this.props.streams && !this.props.streamsLoading && this.props.streams.length < 1 && this.props.location.pathname.startsWith('/portfolios')) {
      this.props.router.push('/configure?fromPortfolio=true');
    }

    if (portfolioContextChanged && currentEffectivePortfolioId) {
      this.props.requestData(currentEffectivePortfolioId);
      this.chartsInitialized = false;
    } else if (selectedPortfolioObjectChanged || !this.chartsInitialized) {      
      this._syncBreakdownSettingsAndCharts(this.props);
    }
  }

  updateFontSize = chart => {};

  handleConfigure = () => {
    this.props.router.push('/portfolio/' + this.props.selectedPortfolio._id);
  };

  handleNew = () => {
    this.props.select({ isNew: true });
    this.props.router.push('/portfolio');
  };

  handleDateChange = (dates) => {
    const { selectedPortfolio, updateDateRange } = this.props;
    if (!selectedPortfolio || !selectedPortfolio._id) return;
    if (!dates || !dates.startDate || !dates.endDate) return;

    const displayDateRangeFrom = moment(dates.startDate).startOf('day').toISOString();
    const displayDateRangeTo = moment(dates.endDate).endOf('day').toISOString();

    updateDateRange(selectedPortfolio._id, displayDateRangeFrom, displayDateRangeTo);
  };

  getPortfolioDateValue = () => {
    const { selectedPortfolio } = this.props;

    if (selectedPortfolio?.displayDateRangeFrom && selectedPortfolio?.displayDateRangeTo) {
      return {
        startDate: moment(selectedPortfolio.displayDateRangeFrom),
        endDate: moment(selectedPortfolio.displayDateRangeTo)
      };
    }
    return {
      startDate: moment().subtract(3, 'months'),
      endDate: moment()
    };
  };

  changePercentile = value => {
    this.setState({ percentile: parseInt(value, 10) });

    trackReportConfigChange(this.getDashboardsNames(), 'ct_percentile', { percent: parseInt(value, 10) });
  };

  changeThreshold = value => {
    this.setState({ threshold: value });

    trackReportConfigChange(this.getDashboardsNames(), 'controls', { variation: value });
  };

  onBreakdownChange = (widget, field) => {
    const { selectedPortfolio, saveSelectedBreakdown, wallmode } = this.props;
    const portfolioId = selectedPortfolio && selectedPortfolio._id;
    if (!portfolioId) {
      return;
    }
     if (!wallmode) {
      saveSelectedBreakdown(portfolioId, widget, field.id);
    }
    this.setState({ [widget]: { ...this.state[widget], name: field.id, search: field.id, value: [field.id] } });
  }

  handleChartExpand = (stateKey, cardId, trackingId) => {
    const newValue = !this.state[stateKey];
    this.setState({ [stateKey]: newValue }, () => {
      const card = document.getElementById(cardId);
      const manager = card && this.gridManagers.find(item => item.gridRef.current && item.gridRef.current.contains(card));
      if (manager) {
        manager.updateWidgetHeight(card, newValue ? 2 : 1);
      }
      this.trackChartDetailsView(trackingId, !newValue);
    });
  };

  handleResize = ev => {
    const chart = ev.target.id.split('-')[1];
    if (this.state.isFullScreen) {
      this.setState(
        { isFullScreen: '' },
        () => this.updateFontSize(chart)
      );
    } else {
      this.setState(
        { isFullScreen: chart },
        () => this.updateFontSize(chart)
      );
      trackPortfolioView(chart);
    }
  };

  trackChartDetailsView(chart, isHidden) {
    if (!isHidden) {
      trackPortfolioView(chart + '_details');
    }
  }
 getBreakDownList(chart) {
    const { filters } = this.props;
    const isCycletime = chart === 'cycletime';
    if (filters) {
      const list = _(filters.dashboards)
        .map(d => d.allCustomFields)
        .flatten()
        .groupBy('name')
        .map((value, key) => ({ name: key, id: _.map(value, v => v.id) }))
        .value();

      if (this.props.app === 'file') {
        const flags = { azure: false, jira: false };
        _.forEach(filters.dashboards, d => {
          if (!d.isCsv && d.isAzure) flags.azure = true;
          if (!d.isCsv && !d.isAzure) flags.jira = true;
        });
        if (flags.azure) {
          list.push({ name: 'Work item types', id: ['labels'] });
        }
        if (flags.jira) {
          list.push({ name: 'Priorities', id: ['labels'] });
        }
      }

      switch (this.props.app) {
        case 'azure':
          list.push({ name: 'Work item types', id: ['labels'] });
          isCycletime && list.push({ name: 'Columns', id: ['statuses'] });
          break;
        case 'asana':
          list.push({ name: 'Tags', id: ['labels'] });
          isCycletime && list.push({ name: 'Sections', id: ['statuses'] });
          break;
        case 'jira':
          list.push({ name: 'Priorities', id: ['labels'] });
          isCycletime && list.push({ name: 'Statuses', id: ['statuses'] });
          break;
        case 'trello':
          list.push({ name: 'Labels', id: ['labels'] });
          isCycletime && list.push({ name: 'Lists', id: ['statuses'] });
          break;
        case 'file': 
          isCycletime && list.push({ name: 'Statuses', id: ['statuses'] });
          break;
      }

      return _.orderBy(list, 'name');
    }
    return [];
  }
  
  getBreakDownName(values) {
    const { filters } = this.props;
    let name;

    if (values.indexOf('labels') > -1) {
      switch (this.props.app) {
        case 'azure':
          return 'Work item types';
        case 'trello':
          return 'Labels';
        case 'asana':
          return 'Tags';
        case 'jira':
          return 'Priorities';
      }
    }

    if (values.indexOf('statuses') > -1) {
      switch (this.props.app) {
        case 'jira':
        case 'file': 
          return 'Statuses';
        case 'azure':
          return 'Columns';
        case 'trello':
          return 'Lists';
        case 'asana':
          return 'Sections';
      }
    }

    _.some(values, value => {
      return _.some(filters.dashboards, dashboard => {
        const cf = _.find(dashboard.allCustomFields, { id: value });
        if (cf) {
          name = cf.name;
          return true;
        }
      });
    });
    return name;
  }
  
  _deriveBreakdownStateForWidget(widgetType, currentProps = this.props) {
    const { stats, selectedPortfolio } = currentProps;

    const breakdownsAvailableMap = stats && stats[`${widgetType}Breakdowns`];
    let defaultName = '';
    let derivedName = '';

    if (breakdownsAvailableMap && typeof breakdownsAvailableMap === 'object' && Object.keys(breakdownsAvailableMap).length > 0) {
      const breakdownKeys = Object.keys(breakdownsAvailableMap);
      defaultName = breakdownKeys[0];
      const persistedPreferences = selectedPortfolio && selectedPortfolio[`${widgetType}`];
      const persistedPreference = persistedPreferences && persistedPreferences.length > 0 ? persistedPreferences[0] : null;
      if (persistedPreference && breakdownKeys.includes(persistedPreference)) {
        derivedName = persistedPreference;
      } else {
        derivedName = defaultName;
      }
    }
    return { ...this.state[widgetType], name: derivedName, search: derivedName, value: [derivedName] };
  }

  _syncBreakdownSettingsAndCharts(propsToUse = this.props) {
    const { stats, selectedPortfolio } = propsToUse;

    if (!stats || !selectedPortfolio || !selectedPortfolio._id || !stats.cycletimeBreakdowns || !stats.throughputBreakdowns) {
      return;
    }

    const newCycleTimeState = this._deriveBreakdownStateForWidget('cycletime', propsToUse);
    const newThroughputState = this._deriveBreakdownStateForWidget('throughput', propsToUse);
    const stateToUpdate = {};
    let needsStateUpdate = false;

    if (!_.isEqual(this.state.cycletime.name, newCycleTimeState.name)) {
      stateToUpdate.cycletime = { ...this.state.cycletime, ...newCycleTimeState };
      needsStateUpdate = true;
    }
    if (!_.isEqual(this.state.throughput.name, newThroughputState.name)) {
      stateToUpdate.throughput = { ...this.state.throughput, ...newThroughputState };
      needsStateUpdate = true;
    }

    if (needsStateUpdate) {
      this.setState(stateToUpdate);
    }
    this.chartsInitialized = true;
  }

  renderPercentiles() {
    if (reportHasNoData(this.props.trends, this.props.loading)) {
      return <ChartPlaceholder shape="table" />;
    }
    return (
      <div className='percentile-progression'>
        {this.props.stats.avgPercentiles &&
          this.props.stats.avgPercentiles.map((p, i) => {
            return (
              <div key={i}>
                <h4>
                  {moment.duration(p.value, 'minutes').format('d[d] h[h] m[m]', { trim: 'mid both' })}
                </h4>
                <p>{p.text}th percentile</p>
              </div>
            );
          })}
      </div>
    );
  }

  renderButtons() {
    const { user, selectedPortfolio } = this.props;
    const access = getPortfolioAccessRights(user, selectedPortfolio);
    const canCreatePortfolios = user && user.permissions && user.permissions.createPortfolios;
    return [
      <SubscribeEDAddOn key="1"></SubscribeEDAddOn>,
      canCreatePortfolios && <DropdownButton
        key="2"
        id="createportfolio-dropdown"
        variant='secondary'
        size='sm'
        title={
          <OverlayTrigger placement="bottom"
            overlay={<Tooltip id="tooltip-createportfolio" className='tooltip_dark'>Create portfolio</Tooltip>}>
            <img src={createIcon} alt="" />
          </OverlayTrigger>
        }
      >
        <li>
          <Button onClick={this.handleNew} className='btn'>
            <span className="title"><img src={createIcon} alt="#"/> Create portfolio</span>
            <span className="help-text">
              Select the value streams you want to include and track performance across your organization.
            </span>
          </Button>
        </li>
      </DropdownButton>,
      this.props.selectedPortfolio && (
        <DropdownButton
          key="3"
          id="dashboards-dropdown"
          size="sm"
          variant="secondary"
          title={
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="tooltip-settings" className="tooltip_dark">
                  Portfolio settings
                </Tooltip>
              }
            >
              <img src={settingsIcon} alt="" />
            </OverlayTrigger>
          }
        >
          {access && access.edit && <li onClick={ev => this.handleConfigure(this.props.selectedPortfolio)}>
            <div className="btn">
              <span className="title">
                <img src={editIcon} alt="#" /> Edit portfolio
              </span>
              <span className="help-text">
                Add or remove value streams and update your portfolio.
              </span>
            </div>
          </li>}
          {access && access.delete && <li>
            <Confirm
              onConfirm={ev => this.props.remove(this.props.selectedPortfolio._id)}
              body={
                <p>
                  Are you sure you want to delete <strong>{this.props.selectedPortfolio.name}</strong>?
                </p>
              }
              confirmText="Delete"
              icon={deleteIcon}
              title="Delete portfolio"
            >
              <div className="btn">
                <span className="title red">
                  <img src={deleteIcon} alt="#" />
                  Delete portfolio
                </span>
                <span className="help-text">Delete this portfolio. This action cannot be undone.</span>
              </div>
            </Confirm>
          </li>}
        </DropdownButton>
      )
    ];
  }

  renderPortfolio() {
    const flowEfficiency = !isNaN(this.props.stats.avgFe);
    const noData = reportHasNoData(this.props.trends, this.props.loading);
    const kpi = value => (noData ? <span className="is-empty">No data available</span> : value);
    const {
      isFullScreen,
      wp,
      th,
      wat,
      ct,
      fe,
    } = this.state;
    const breakDownItemsCt = this.props.stats.cycletimeBreakdowns
      ? Object.keys(this.props.stats.cycletimeBreakdowns).map(key => ({ name: key, id: key }))
      : [];
    const breakDownItemsTh = this.props.stats.throughputBreakdowns
      ? Object.keys(this.props.stats.throughputBreakdowns).map(key => ({ name: key, id: key }))
      : [];
    const subsetColors = _(this.props.trends && this.props.trends.throughput)
      .map(({ name, color }) => [name, color])
      .fromPairs()
      .value();

    return (
      <div className="report-wrap portfolios">
        {!this.props.wallmode && this.props.selectedPortfolio && this.props.selectedPortfolio._id && (
          <div className="button_tools" style={{ justifyContent: 'space-between' }}>
            <h1 className="report-page-title">Portfolios</h1>
            <DateRangePicker
              value={this.getPortfolioDateValue()}
              updateValue={this.handleDateChange}
            />
          </div>
        )}

        {this.props.loading && (
          <div className="table-loading">
            <Loading />
          </div>
        )}

        {/*<NoData show={!this.props.trends.avgCt} />*/}

        {/* the summary (3190 EX 5): the portfolio's numbers for the period, then its cycle time percentiles in order */}
        <div className="row-cell-list report-summary report-kpis">
          <div className="cell">
            <div className="cell-header">
              <h4>Avg. cycle time {kpi(<span>{moment.duration(this.props.stats.avgCt, 'minutes').format('d[d] h[h] m[m]', { trim: 'mid both' })}</span>)}</h4>
            </div>
          </div>
          <div className="cell">
            <div className="cell-header">
              <h4>Throughput {kpi(<span>{this.props.stats.avgThroughput} work items</span>)}</h4>
            </div>
          </div>
          {flowEfficiency && (
            <div className="cell">
              <div className="cell-header">
                <h4>Avg. flow efficiency {kpi(<span>{this.props.stats.avgFe}%</span>)}</h4>
              </div>
            </div>
          )}
        </div>
        <div className="row-cell-list report-summary">
          <div className="cell">
            <div className="cell-header">
              <h4>Avg. cycle time percentiles</h4>
            </div>
            <div className="cell-content">
              {this.renderPercentiles()}
            </div>
          </div>
        </div>

        <h5 className="report-section-title">Trends</h5>
        <div ref={this.trendsGridRef} className="grid-stack row-cell-list">
          <div className="grid-stack-item" gs-w="6" gs-h={`${ct ? 2 : 1}`} style={isFullScreen === 'ctt' ? { zIndex: 9999 } : ct ? {height: 'calc(2 * var(--gs-cell-height))'} : {}} id="card-ctb">
            <div className={`cell ${isFullScreen === 'ctt' ? 'fullscreen' : ''} ${cardIsEmpty(this.props.trends.avgCt, this.props.loading) ? 'cell--empty' : ''} ${ ct ? 'line-chart' : '' }`}>
              <div className='cell-header'>
                <h4>Cycle time</h4>
                <Button variant="flat" size="md" className={ct ? 'active' : ''} onClick={() => this.handleChartExpand('ct', 'card-ctb', 'ctt')}>
                  <img src={lineChartOnIcon} alt="toggleFullScreen" />
                </Button>
                <Button id="fullscreen-ctt" variant="flat" size="md" onClick={this.handleResize}>
                  <img src={isFullScreen === 'ctt' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <DragIcon customizeMode={this.props.customizeMode} />
              </div>

              <div className="cell-content">
                <LineChart
                  loading={this.props.loading}
                  id="ct"
                  className='chart'
                  detailed={ct}
                  isFullScreen={isFullScreen === 'ctt'}
                  plural={true}
                  tooltipLabel="Avg. cycle time"
                  unit="day"
                  data={this.props.trends.avgCt}
                />
              </div>
            </div>
          </div>

          <div className="grid-stack-item" gs-w="6" gs-h={`${th ? 2 : 1}`} style={isFullScreen === 'tht' ? { zIndex: 9999 } : th ? {height: 'calc(2 * var(--gs-cell-height))'} : {}} id="card-throughput-trends">
            <div className={`cell ${isFullScreen === 'tht' ? 'fullscreen' : ''} ${cardIsEmpty(this.props.trends.throughput, this.props.loading) ? 'cell--empty' : ''} ${ th ? 'line-chart' : '' }`}>
              <div className='cell-header'>
                <h4>Throughput trends</h4>
                <Button variant="flat" size="md" className={th ? 'active' : ''} onClick={() => this.handleChartExpand('th', 'card-throughput-trends', 'tht')}>
                  <img src={lineChartOnIcon} alt="toggleFullScreen" />
                </Button>
                <Button id="fullscreen-tht" variant="flat" size="md" onClick={this.handleResize}>
                  <img src={isFullScreen === 'tht' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <DragIcon customizeMode={this.props.customizeMode} />
              </div>

              <div className="cell-content">
                <LineChart
                  loading={this.props.loading}
                  id="throughput"
                  className='chart'
                  detailed={th}
                  isFullScreen={isFullScreen === 'tht'}
                  plural={true}
                  tooltipLabel="Work items"
                  unit="item"
                  data={this.props.trends.throughput}
                />
              </div>
            </div>
          </div>

          <div className="grid-stack-item" gs-w="6" gs-h={`${wp ? 2 : 1}`} style={isFullScreen === 'wip' ? { zIndex: 9999 } : wp ? {height: 'calc(2 * var(--gs-cell-height))'} : {}} id="card-wip">
            <div className={`cell ${isFullScreen === 'wip' ? 'fullscreen' : ''} ${cardIsEmpty(this.props.trends.wip, this.props.loading) ? 'cell--empty' : ''} ${ wp ? 'line-chart' : '' }`}>
              <div className='cell-header'>
                <h4>WIP</h4>
                <Button variant="flat" size="md" className={wp ? 'active' : ''} onClick={() => this.handleChartExpand('wp', 'card-wip', 'wip')}>
                  <img src={lineChartOnIcon} alt="toggleFullScreen" />
                </Button>
                <Button id="fullscreen-wip" variant="flat" size="md" onClick={this.handleResize}>
                  <img src={isFullScreen === 'wip' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <DragIcon customizeMode={this.props.customizeMode} />
              </div>

              <div className="cell-content">
                <LineChart
                  loading={this.props.loading}
                  id="wip"
                  className='chart'
                  detailed={wp}
                  isFullScreen={isFullScreen === 'wip'}
                  showExactDate={true}
                  plural={false}
                  tooltipLabel="Work items"
                  unit="item"
                  data={this.props.trends.wip}
                />
              </div>
            </div>
          </div>

          <div className="grid-stack-item" gs-w="6" gs-h={`${wat ? 2 : 1}`} style={isFullScreen === 'wat' ? { zIndex: 9999 } : wat ? {height: 'calc(2 * var(--gs-cell-height))'} : {}} id="card-wipAge">
            <div className={`cell ${isFullScreen === 'wat' ? 'fullscreen' : ''} ${cardIsEmpty(this.props.trends.avgWat, this.props.loading) ? 'cell--empty' : ''} ${ wat ? 'line-chart' : '' }`}>
              <div className='cell-header'>
                <h4>WIP age</h4>
                <Button variant="flat" size="md" className={wat ? 'active' : ''} onClick={() => this.handleChartExpand('wat', 'card-wipAge', 'wat')}>
                  <img src={lineChartOnIcon} alt="toggleFullScreen" />
                </Button>
                <Button id="fullscreen-wat" variant="flat" size="md" onClick={this.handleResize}>
                  <img src={isFullScreen === 'wat' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <DragIcon customizeMode={this.props.customizeMode} />
              </div>

              <div className="cell-content">
                <LineChart
                  loading={this.props.loading}
                  id="wat"
                  className='chart'
                  detailed={wat}
                  showExactDate={true}
                  isFullScreen={isFullScreen === 'wat'}
                  plural={true}
                  tooltipLabel="Avg. WIP age time"
                  unit="day"
                  data={this.props.trends.avgWat}
                />
              </div>
            </div>
          </div>
        </div>

        <h5 className="report-section-title">Distribution & composition</h5>
        <div ref={this.distributionGridRef} className="grid-stack row-cell-list">
          <div className="grid-stack-item" gs-w="4" id="card-cycletime">
            <div className="widget">
              <PieChartWidget
                loading={this.props.loading}
                wallmode={this.props.wallmode}
                className="cell cell-33"
                name="cycletime-breakdown"
                title={
                  <React.Fragment>
                    Cycle Time Breakdown
                    <DragIcon customizeMode={this.props.customizeMode} />
                  </React.Fragment>
                }
                formatter={(p) => formatCycletimeLabel(p, this.props.filters.timePrecision)}
                breakdowns={this.props.stats.cycletimeBreakdowns}
                options={breakDownItemsCt}
                colors={subsetColors}
                selected={this.state.cycletime.name}
                onSelect={(field) => this.onBreakdownChange('cycletime', field)}
              />
            </div>
          </div>

          <div className="grid-stack-item" gs-w="4" id="card-throughput">
            <div className="widget">
              <PieChartWidget
                loading={this.props.loading}
                wallmode={this.props.wallmode}
                className="cell cell-33"
                name="throughput-breakdown"
                title={
                  <React.Fragment>
                    Throughput breakdown
                    <DragIcon customizeMode={this.props.customizeMode} />
                  </React.Fragment>
                }
                formatter={(p) => formatThroughputLabel(p)}
                breakdowns={this.props.stats.throughputBreakdowns}
                options={breakDownItemsTh}
                colors={subsetColors}
                selected={this.state.throughput.name}
                onSelect={(field) => this.onBreakdownChange('throughput', field)}
              />
            </div>
          </div>

          <div className="grid-stack-item" gs-w="6" style={isFullScreen === 'percentile' ? { zIndex: 9999 } : {}} id="card-percentile-trends">
            <div className={`cell ${isFullScreen === 'percentile' ? 'fullscreen' : ''} ${cardIsEmpty(this.props.trends.percentiles, this.props.loading) ? 'cell--empty' : ''}`}>
              <div className='cell-header'>
                <h4>Percentiles</h4>
                <Button id="fullscreen-percentile" variant="flat" size="md" onClick={this.handleResize}>
                  <img src={isFullScreen === 'percentile' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <DragIcon customizeMode={this.props.customizeMode} />
              </div>

              <div className="cell-content">
                <LineChart
                  loading={this.props.loading}
                  id="percentiles-trend"
                  keepColors
                  className='chart'
                  isFullScreen={isFullScreen === 'percentile'}
                  tooltipLabel=""
                  unit="day"
                  showLegend={isFullScreen === 'percentile'}
                  legendSuffix="%"
                  data={this.props.trends.percentiles}
                />
              </div>
            </div>
          </div>

          <div className="grid-stack-item" gs-w="6" gs-h={`${fe ? 2 : 1}`} style={isFullScreen === 'fe' ? { zIndex: 9999 } : fe ? { height: 'calc(2 * var(--gs-cell-height))' } : {}} id="card-flow-efficiency">
            <div className={`cell ${isFullScreen === 'fe' ? 'fullscreen' : ''} ${cardIsEmpty(this.props.trends.flowEfficiency, this.props.loading) ? 'cell--empty' : ''} ${ fe ? 'line-chart' : '' }`}>
              <div className='cell-header'>
                <h4>Flow Efficiency</h4>
                <Button variant="flat" size="md" className={fe ? 'active' : ''} onClick={() => this.handleChartExpand('fe', 'card-flow-efficiency', 'fe')}>
                  <img src={lineChartOnIcon} alt="toggleFullScreen" />
                </Button>
                <Button id="fullscreen-fe" variant="flat" size="md" onClick={this.handleResize}>
                  <img src={isFullScreen === 'fe' ? expandIcon : collapseIcon} alt="toggleFullScreen" />
                </Button>
                <DragIcon customizeMode={this.props.customizeMode} />
              </div>

              <div className="cell-content">
                <LineChart
                  loading={this.props.loading}
                  id="fe"
                  className='chart'
                  detailed={fe}
                  isFullScreen={isFullScreen === 'fe'}
                  tooltipLabel="Avg. flow efficiency"
                  unit="%"
                  data={this.props.trends.flowEfficiency}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { wallmode, streams, streamsLoaded, loaded } = this.props;
    const emptyPath = streamsLoaded  && loaded ? streams && streams.length > 1 ? "/no-portfolios": "/no-enough-streams": null;
    return [
      streamsLoaded && (
        <ValueStreamSelector
          key="1"
          title=""
          items={this.props.portfolios}
          selectedItem={this.props.selectedPortfolio}
          onSelect={this.props.selectPortfolio}
          onSaveSelected={this.props.saveSelectedPortfolio}
          onListAll={this.props.listAllPortfolios}
          loaded = {this.props.loaded}
          noItems={!this.props.portfolios || this.props.portfolios.length === 0}
          basePath="/portfolios"
          emptyPath={emptyPath}
          searchPlaceholder="Search Portfolio"
          defaultItemImage={portfolioIcon}
          defaultItemIdFromUserConfigKey="selectedPortfolio"
          buttons={wallmode ? null : this.renderButtons()}
          dataIsLoading={this.props.loading}
          showTeamInHeader={true}
        />
      ),
      <div key="2" id="portfolio" className="content-wrap">
        <Helmet>
          <title>{pageTitle('Portfolio')}</title>
        </Helmet>
        {this.renderPortfolio()}
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => {
  return {
    handleError: err => dispatch(handleError(err)),
    requestData: id => dispatch(requestData(id)),
    select: (itemId, viewId) => dispatch(selectPortfolio(itemId, viewId)),
    remove: id => dispatch(deletePortfolio(id)),
    listAllPortfolios: () => dispatch(listAll()),
    selectPortfolio: (item, viewId) => dispatch(selectPortfolio(item, viewId)),
    saveSelectedPortfolio: id => dispatch(saveSelected(id)),
    saveSelectedBreakdown: (id, chart, value) => dispatch(saveSelectedPortfolioBreakdown(id, chart, value)),
    getStreams: () => dispatch(streamsAll()),
    updateDateRange: (portfolioId, displayDateRange, unifyDateRange) => dispatch(updateDateRange(portfolioId, displayDateRange, unifyDateRange)),
  };
};

const mapStateToProps = state => {
  return {
    app: state.app.app,
    wallmode: state.app.wallmode,
    loading: state.portfolio.isLoading,
    loaded: state.portfolio.loaded,
    dateRangeLoading: state.portfolio.dateRangeLoading,
    stats: state.portfolio.stats,
    trends: state.portfolio.trends,
    portfolios: state.portfolio.portfolios,
    selectedPortfolio: state.portfolio.selectedPortfolio,
    user: state.auth.user,
    streams: state.report.streams,
    streamsLoading: state.report.isLoading,
    streamsLoaded: state.report.loaded,
    filters: state.report.filters,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Portfolios));
export { Portfolios };